import Booking from '@solvhealth/types/interfaces/Booking';
import { useDispatch } from 'react-redux';
import history from '~/core/history';
import { isPremiumBooking, isProviderGroupBooking, isTelemedBooking } from '~/core/util/booking';
import { FETCH_PROVIDER_EXTERNAL } from '~/sagas/providerGroups';
import { ORIGIN_REACT_MOBILE_APP } from '~/constants/index';
import { setOrigin } from '~/actions/newBooking';
import { PREMIUM_IN_PERSON_SLOT_SELECTOR } from '~/components/AccountGetsMarried/components/GetCare/components/PremiumInPersonSlotSelector';
import useToggleRuntimeModal from '~/hooks/runtime/useToggleRuntimeModal';

/**
 * Returns a callback to trigger a rebooking
 *
 * @returns A callback
 */
export function useRebooking(booking: Booking, showModal: () => void) {
  const dispatch = useDispatch();
  const [, toggleInPersonBookingModal] = useToggleRuntimeModal(PREMIUM_IN_PERSON_SLOT_SELECTOR);

  return () => {
    dispatch(setOrigin(ORIGIN_REACT_MOBILE_APP));
    if (isProviderGroupBooking(booking)) {
      // need to ensure that we re-fetch slots before pushing user back to provider page
      const providerId = booking.providerId || booking.provider_id;
      dispatch({
        type: FETCH_PROVIDER_EXTERNAL,
        providerId,
      });
      history.push(`/provider/-${providerId}`);
    } else if (isPremiumBooking(booking) && isTelemedBooking(booking)) {
      history.push('/book');
    } else if (isPremiumBooking(booking) && !isTelemedBooking(booking)) {
      toggleInPersonBookingModal();
      history.push(`/account/home/${booking.userProfileId ?? booking.user_profile_id ?? ''}`);
    } else {
      showModal();
    }
  };
}
